import type { StoryResponse } from "@/types/content";

export default function StoryResponses({ items }: { items: StoryResponse[] }) {
  if (!items.length) return null;

  return (
    <section className="mt-10" aria-labelledby="story-response-title">
      <h2 id="story-response-title" className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
        <i className="ri-chat-check-line text-primary-600" aria-hidden="true"></i>
        回应与补充
      </h2>
      <div className="mt-5 space-y-4">
        {items.map((item) => (
          <blockquote
            key={item.from}
            className="rounded-lg border-l-4 border-accent-500 bg-accent-50 px-5 py-4"
          >
            <p className="text-sm leading-relaxed text-accent-950">{item.text}</p>
            <footer className="mt-3 flex items-center gap-2 text-xs font-label font-medium text-accent-800">
              <i className="ri-user-3-line" aria-hidden="true"></i>
              {item.from}
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}